/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import LocalAnchor from './handler/dashboardHyperlinkHandlerLocalAnchor';
import LocalPage from './handler/dashboardHyperlinkHandlerLocalPage';
import RemotePage from './handler/dashboardHyperlinkHandlerRemotePage';
import RemoteAnchor from './handler/dashboardHyperlinkHandlerRemoteAnchor';
import Reference from './handler/dashboardHyperlinkHandlerReference';
import ReportExecution from './handler/dashboardHyperlinkHandlerReportExecution';
import ReportDashletExecution from './handler/dashboardHyperlinkHandlerReportDashletExecution';
import AdhocExecution from './handler/dashboardHyperlinkHandlerAdhocExecution';
import hyperlinkTypes from 'bi-report/src/bi/report/jive/enum/hyperlinkTypes';

export default {
    [hyperlinkTypes.LOCAL_ANCHOR]: LocalAnchor,
    [hyperlinkTypes.LOCAL_PAGE]: LocalPage,
    [hyperlinkTypes.REMOTE_PAGE]: RemotePage,
    [hyperlinkTypes.REMOTE_ANCHOR]: RemoteAnchor,
    [hyperlinkTypes.REFERENCE]: Reference,
    [hyperlinkTypes.REPORT_EXECUTION]: ReportExecution,
    [hyperlinkTypes.REPORT_DASHLET_EXECUTION]: ReportDashletExecution,
    [hyperlinkTypes.ADHOC_EXECUTION]: AdhocExecution
};